import { render } from "./PatientsDatatableTDImportance.vue?vue&type=template&id=321d635e"
import script from "./PatientsDatatableTDImportance.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDImportance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__